import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const WormInfestationPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Worm Infestation</h1>
        <section className="mb-8">
          <p>Worm infestation is a common digestive problem, especially in children, caused by parasitic worms in the intestines. Our natural therapies focus on eliminating worms, restoring digestive health, and preventing recurrence through herbal remedies and lifestyle changes.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Contaminated food or water</li>
            <li>Poor hygiene</li>
            <li>Contact with infected soil</li>
            <li>Close contact with infected individuals</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Abdominal pain</li>
            <li>Loss of appetite</li>
            <li>Weight loss</li>
            <li>Itching around the anus</li>
            <li>Digestive disturbances</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use anti-parasitic herbs, digestive tonics, and lifestyle modifications to naturally treat worm infestation. Our approach focuses on eliminating worms, restoring digestive health, and preventing recurrence through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Eliminates worms naturally</li>
            <li>Restores digestive health</li>
            <li>No harsh side effects</li>
            <li>Prevents recurrence</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Maintain good hygiene</li>
            <li>Wash hands before eating</li>
            <li>Drink clean, filtered water</li>
            <li>Cook food thoroughly</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: How long does it take to eliminate worms?</strong>
            <p>A: Most patients see improvement within 1-2 weeks of consistent treatment.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment safe for children?</strong>
            <p>A: Yes, our natural remedies are gentle and suitable for all age groups.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Can this treatment prevent recurrence?</strong>
            <p>A: Yes, our holistic approach helps prevent recurrence by addressing root causes and promoting hygiene.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from worm infestation—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default WormInfestationPage; 